import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import NotFound from "../pages/NotFound";
import { UserRole } from "../user/enums/UserRole";
import BranchesPage from "./components/BranchesPage";

export function BranchRoutes({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[UserRole.School]}
          component={BranchesPage}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
